import { render, staticRenderFns } from "./PaymentFallback.vue?vue&type=template&id=20f4a34d&"
import script from "./PaymentFallback.vue?vue&type=script&lang=js&"
export * from "./PaymentFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20f4a34d')) {
      api.createRecord('20f4a34d', component.options)
    } else {
      api.reload('20f4a34d', component.options)
    }
    module.hot.accept("./PaymentFallback.vue?vue&type=template&id=20f4a34d&", function () {
      api.rerender('20f4a34d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/components/PaymentFallback.vue"
export default component.exports